const state = {
  state: {
    list:[],
    count:0,
    recruitScrollY:0,
  },
}
export default{
  state,
}



// WEBPACK FOOTER //
// ./src/store/modules/task.js